import { makeAutoObservable } from "mobx";
import { ONLINE_CONTACT_DETAILS_KEY } from "../../storageManagers";
export class PQrWaiterOrderDetails {
    constructor(params) {
        this.type = "QrWaiter";
        this.isFulfillmentEditable = false;
        this.promotionScheme = params.promotionScheme;
        makeAutoObservable(this);
    }
    initialize() {
        this.promotionScheme.initialize();
    }
    dispose() {
        this.promotionScheme.dispose();
    }
    get promotionInstances() {
        return this.promotionScheme.promotionInstances;
    }
    clearCoupon() {
        this.promotionScheme.clearCoupon();
    }
    get couponState() {
        return this.promotionScheme.couponState;
    }
    get doesAnyPromotionRequireMarketingConsents() {
        return this.promotionScheme.doesAnyPromotionRequireMarketingConsents;
    }
    disableMarketingPromotionInstances() {
        this.promotionScheme.disableMarketingPromotionInstances();
    }
    // TODO: remove this?
    get isStoredContact() {
        return localStorage.getItem(ONLINE_CONTACT_DETAILS_KEY) !== null;
    }
}
